import React from 'react';
import {ButtonPrimary} from '@homeaway/react-buttons';
import './styles.less';
import {isPPM} from '../../utils/validate';

export default class DialogBox extends React.Component {
    constructor(props) {
        super(props);
    }

    getHeadingDesc = () => {
        const {headingDesc} = this.props;
        return (headingDesc) ? (<div className="dialog-box-wrapper-heading-desc">{headingDesc}</div>) : null;
    };

    getDialogBoxClass = () => (isPPM(this.props.userType)) ? 'welcome-dialog-box' : 'dialog-box-content-wrapper';

    render() {
        const {handleSubmit, actionLabel, heading, dialogHeading, dialogFooter, styles, contents, isButtonDisabled, isGql, footer} = this.props;
        const {height, width, innerPadding, outerPaddingTop, outerPaddingBottom} = styles;

        return (
            <div style={{paddingTop: outerPaddingTop, paddingBottom: outerPaddingBottom}}>
                {
                    heading
                        ? <h2 className="dialog-box-wrapper-heading">
                            {/* eslint-disable-next-line react/no-danger */}
                            <div dangerouslySetInnerHTML={{__html: heading}}/>
                            {this.getHeadingDesc()}
                        </h2>
                        : null
                }
                <div className={this.getDialogBoxClass()} style={{maxWidth: width, width: '100%', minHeight: height, height: '100%', paddingLeft: innerPadding, paddingRight: innerPadding}}>
                    {!isGql && <h4 className="dialog-box-heading">{dialogHeading}</h4>}
                    <div className="dialog-box-wrapper-contents">
                        {contents}
                    </div>
                    {
                        (actionLabel)
                            ? <ButtonPrimary
                                    className="dialog-box-action-button"
                                    label={actionLabel}
                                    onClick={handleSubmit}
                                    type="submit"
                                    disabled={isButtonDisabled}
                              />
                            : null
                    }
                    {
                        dialogFooter
                        ? (
                            // eslint-disable-next-line react/no-danger
                            <div className="dialog-box-footer" dangerouslySetInnerHTML={{__html: dialogFooter}} />
                            ) : null
                    }
                </div>
                { footer ?
                    <div style={{ paddingTop: outerPaddingTop, paddingBottom: outerPaddingBottom }}>
                        <div className="dialog-box-wrapper-footer">
                            {footer.footer_1}
                        </div>
                        <div className="dialog-box-wrapper-footer">
                            {footer.footer_2}
                        </div>
                    </div>
                    : null
                }
            </div>
        );
    }
}
